module.exports = __webpack_public_path__ + "img/top_btn.c494d9aa.png";